import { Grid } from '@mui/material';
import styled from 'styled-components';

export const Wrapper = styled(Grid)`
  .container {
    z-index: 1;
  }
`;
